import * as React from "react";
import { mapCuratedSet } from "src/transformer";
import { RouteComponentProps, Route, withRouter } from "react-router";
import { WithToast, BPMCurated, errorToString, resolveCurrentUrl, CuratedListView, Loader, withToast, CuratedDetail } from 'bpm-web-generic';
import { Analytics } from "src/manager/AnalyticsManager";
import { curatedSetsAPI } from "src/api/config";
export interface CuratedSetProps extends RouteComponentProps<{ set: string }>, WithToast {
    page: string;
}
interface CuratedSetState {
    sets?: { [key: number]: BPMCurated[] },
    categories?: { id: number, name: string }[],
    related?: BPMCurated[];
    set?: BPMCurated;
}
class CuratedSetView extends React.Component<CuratedSetProps, CuratedSetState> {

    constructor(props: CuratedSetProps) {
        super(props);
        this.state = {

        }
    }

    componentDidMount() {
        this.loadCuratedSets()
        if (this.props.match.params.set) {
            this.loadSetForSlug().then(set => {
                Analytics.trackView('curated-set', `${set.id}`)
            })
        }
    }

    componentDidUpdate(prevProps: CuratedSetProps) {
        if (prevProps.match.params.set != this.props.match.params.set) {
            this.setState({ set: undefined }, () => {
                if (this.props.match.params.set) {
                    this.loadSetForSlug().then(set => {
                        Analytics.trackView('curated-set', `${set.id}`)
                    })
                }
            })
        }
    }

    private loadSetForSlug() {
        return curatedSetsAPI.getCuratedSetsBySlug(this.props.match.params.set).then(({ data }) => {
            curatedSetsAPI.getCuratedSetsByCurator(data.curator, data.slug, 'music').then(({ data }) => {
                const mapRelated = data.slice(0, 4).map(relatedSet => {
                    return mapCuratedSet(relatedSet)
                })
                this.setState({ related: mapRelated })
            })
            this.setState({ set: mapCuratedSet(data) })
            return mapCuratedSet(data)
        }).catch(err => {
            return new Promise<BPMCurated>((resolve) => {
                errorToString(err).forEach(error => {
                    this.props.showToast('danger', error)
                }, () => {
                    resolve(this.loadSetForSlug())
                })
            })
        })
    }

    private loadCuratedSets() {
        curatedSetsAPI.getCuratedSets(undefined, undefined, 'music').then(({ data }) => {

            const categories = data.map((d) => d.category).unique('id')
            const final_sets: { [key: number]: BPMCurated[] } = {}

            data.forEach((set) => {
                if (!final_sets[set.category.id.toString()]) {
                    final_sets[set.category.id.toString()] = []
                }
                final_sets[set.category.id.toString()].push(mapCuratedSet(set))
            })

            // final_sets['featured'] = info.featured.map(mapCuratedSet)
            this.setState({
                categories: categories,
                sets: final_sets
            })
        }).catch(err => {
            errorToString(err).forEach(error => {
                this.props.showToast('danger', error)
            }, () => {
                this.loadCuratedSets()
            })
        })
    }

    private navigateToSet(set: BPMCurated) {
        this.props.history.push('/' + resolveCurrentUrl(this.props.page, set.slug))
    }

    private renderSetDetail() {
        if (this.state.set) {
            const featured = Object.keys(this.state.sets || {}).reduce((previous, current) => {
                this.state.sets![current].forEach((curated: BPMCurated) => {
                    if (curated.featured) {
                        previous.push(curated)
                    }
                })
                return previous;
            }, new Array<BPMCurated>())
            return <div>
                <CuratedDetail
                    {...this.props}
                    hideUpdated
                    set={this.state.set}
                    related={this.state.related}
                    onVideoClick={() => {
                        Analytics.trackClick('curated_video', this.state.set!.id.toString())
                    }}
                    onCuratedSetClick={(url: string) => this.props.history.push(url)}
                />
                {featured.length > 0 && <CuratedListView sets={featured} title={'Featured'} onClick={(set) => {
                    this.navigateToSet(set)
                }} style={{ paddingTop: '40px' }} />}
            </div>
        } else {
            return <Loader />
        }
    }

    public render() {
        if (!this.state.categories) {
            return <Loader />
        } else {
            if (this.props.match.params.set) {
                return this.renderSetDetail()
            }
            return <div>
                {this.state.categories.map(category => {
                    return <CuratedListView hideUpdated sets={this.state.sets![category.id.toString()] || []} title={category.name} key={category.id} onClick={(set) => {
                        this.navigateToSet(set)
                    }} style={{ paddingBottom: '40px' }} />
                })}
            </div>
        }
    }
}
const CSD = withToast(CuratedSetView)
export default withRouter(class CuratedSetViewRouted extends React.Component<RouteComponentProps<{ page: string }>> {
    public render() {
        return <Route path={resolveCurrentUrl(this.props.match.url, '/:set?')} render={(p) => {
            return <CSD {...this.props} {...p} page={this.props.match.params.page} />
        }} />
    }
})


// WEBPACK FOOTER //
// ./src/pages/CuratedSet.tsx